import React from 'react';
import s from './message-list.module.scss';
import { MessageItem } from './message-item';

export const MessageGroup = React.memo(({ date, messages, profile, onRead }) => {
  return (
    <>
      {messages.map((msg) => (
        <MessageItem
          key={msg.id}
          message={msg}
          isMine={profile?.id === msg.sender_id}
          onRead={onRead}
        />
      ))}
      <div className={s.date}>{date}</div>
    </>
  );
});
